import { useFormikContext } from "formik";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import { OptionsEnum } from "../../../Enumeration/OptionsEnum";
import { CountryEnum } from "../../../Enumeration/CountryEnum";
import {OK } from "../../../Utils/GlobalValues";
import CsplAchField from "../../CsplControls/CsplAch/CsplAchField";
import CsplRadioButtonField from "../../CsplControls/CsplRadioButton/CsplRadioButtonField";
import CsplTextBoxField from "../../CsplControls/CsplTextBox/CsplTextBoxField";
import TaxResidenceTable from "./TaxResidenceTable";
import UseFormikHelper from "../../../Utils/UseFormikHelper";
import TaxDeclarationTermsAndCondition from "./TaxDeclarationTermsAndCondition"
import CsplCheckboxField from "../../CsplControls/CsplCheckBox/CsplCheckboxField";
import AlertModal from "../../CsplModal/AlertModal";
import CsplDragDrop from "../../CsplControls/CsplDragDrop/CsplDragDrop";
import "./PersonalInfoDetails.css";

function TaxDeclaration(props) {
  const [taxResCountryLookupName, setTaxResCountryLookupName] = useState("");
  const [showTACDialog, setShowTACDialog] = useState(false);
  const [count, setCount] = useState(0);
  const [ showChequeUpload,  setShowChequeUpload] = useState(false);

  const { values, setFieldValue, setTouched } = useFormikContext();
  const residentialStatusList = [
    OptionsEnum.Resident,
    OptionsEnum.Non_Resident,
    OptionsEnum.OCI_Card_Holder
  ];
  const applicationContext = useContext(KycApplicationContext);
  let isDisabled = applicationContext.disableForm;
  const { defaultValueFromOtherField, clearFieldValue } = UseFormikHelper();
  const taxDeclaration = [
    OptionsEnum.Tax_Resident_Of_India_Only,
    OptionsEnum.Tax_Resident_Of_countries_Other_Than_Us,
    OptionsEnum.Tax_Resident_Of_Us_Or_Canada,
  ];
  const { t } = useTranslation("common");

  //handler Based On Country Value
  const handleStateBasedOnCountry = (value) => {
    setFieldValue("personalInfoDTO.taxDeclarationDTO.countryOfBirth", value);
    if (value && value.toUpperCase() === CountryEnum.INDIA) {
      clearFieldValue("personalInfoDTO.taxDeclarationDTO.stateOfBirth", "");
    } else {
      clearFieldValue(
        "personalInfoDTO.taxDeclarationDTO.stateOfBirthObj",
        null
      );
    }
  };

  //initialize tax declaration countries
  useEffect(() => {
     
    if (
      values.personalInfoDTO.taxDeclarationDTO &&
      (!values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails ||
        values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails
          .length == 0)
    ) {
      values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails = []; 
      setCount(0)
    }
    if (
      values.personalInfoDTO.taxDeclarationDTO &&
      values.personalInfoDTO.taxDeclarationDTO.taxDeclaration !==
        OptionsEnum.Tax_Resident_Of_India_Only
    ) {
      setTaxResidenceCountryLookupName(
        values.personalInfoDTO.taxDeclarationDTO.taxDeclaration
      );
      setCount(0)
       
    }
    
    changeShowUploadValue();
    
  }, []);

  function changeShowUploadValue(){
    if(values &&
      values.personalInfoDTO &&
      values.personalInfoDTO.taxDeclarationDTO &&
      values.personalInfoDTO.taxDeclarationDTO.residentOfIndia &&
      values.personalInfoDTO.taxDeclarationDTO.residentOfIndia !==
        OptionsEnum.Resident ){
          if(applicationContext.currentWidget.status === "Completed" &&  showChequeUpload === false &&
            (values.personalInfoDTO.taxDeclarationDTO && 
              ((values.personalInfoDTO.taxDeclarationDTO.chequeFileName === null || values.personalInfoDTO.taxDeclarationDTO.chequeFileName === undefined)  && 
            values.personalInfoDTO.taxDeclarationDTO.indianPassportFileName && 
            values.personalInfoDTO.taxDeclarationDTO.visaWorkPermitFileName && 
            values.personalInfoDTO.taxDeclarationDTO.currentOverseasAddressProofFileName))){
              setFieldValue(
                "personalInfoDTO.taxDeclarationDTO.showChequeUpload",
                "false"
              );
            }else{
              if(applicationContext.currentHolder.entityTypeName === "First Holder"){
                setFieldValue(
                  "personalInfoDTO.taxDeclarationDTO.showChequeUpload",
                  "true"
                ); 
              }else{
                setFieldValue(
                  "personalInfoDTO.taxDeclarationDTO.showChequeUpload",
                  "false"
                ); 
              }
             
            }
          
        }else{
          setFieldValue(
            "personalInfoDTO.taxDeclarationDTO.showChequeUpload",
            "false"
          );
        }
  }

  //Handler Based On Residential Status
  const handleDefaultResidentialStatus = (e) => {
    e.preventDefault();
    setFieldValue(e.target.name, e.target.value);
    if (e.target.value === OptionsEnum.Resident) {
      clearFieldValue("personalInfoDTO.taxDeclarationDTO.passportNo", "");
      clearUploadData();
    }
  };

  //clear upload data
  function clearUploadData() {
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.currentOverseasAddressProofImage",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.currentOverseasAddressProofFileName",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.currentOverseasAddressProofImagePath",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.visaWorkPermitImage",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.visaWorkPermitFileName",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.visaWorkPermitImagePath",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.indianPassportImage",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.indianPassportFileName",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.indianPassportImagePath",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.chequeImage",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.chequeFileName",
      ""
    );
    clearFieldValue(
      "personalInfoDTO.taxDeclarationDTO.chequeImagePath",
      ""
    );
  }

  //Handler based on tax residence
  const handleTaxDeclaration = (e) => {
    e.preventDefault();
    setTimeout(() => {
      setFieldValue(e.target.name, e.target.value);
    }, 10);
    setTouched(
      values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails,
      false
    );
    values.personalInfoDTO.taxDeclarationDTO.taxDeclaration = e.target.value;
    if (e.target.value !== OptionsEnum.Tax_Resident_Of_India_Only) {
      addDefaultFirstRow();
    } else {
      values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails.splice(0);
      defaultValueFromOtherField(
        "personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails",
        "personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails"
      );
      if (props.onSaveToStore && typeof props.onSaveToStore === "function") {
        props.onSaveToStore(values);
      }
    }
    setTaxResidenceCountryLookupName(e.target.value);
  };

  //handle lookup based on tax residence
  function setTaxResidenceCountryLookupName(taxDeclarationValue) {
    if (
      taxDeclarationValue ===
      OptionsEnum.Tax_Resident_Of_countries_Other_Than_Us
    ) {
      setTaxResCountryLookupName("CountryListException");
    } else if (
      taxDeclarationValue === OptionsEnum.Tax_Resident_Of_Us_Or_Canada
    ) {
      setTaxResCountryLookupName("countryByCountryNames");
    }
  }

  function addDefaultFirstRow() {
    values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails = [
      getNewEmptyRow(),
    ];
    if (props.onSaveToStore && typeof props.onSaveToStore === "function") {
      props.onSaveToStore(values);
    }
  }

  function getNewEmptyRow() {
    return {
      countryOfTaxResidency: null,
      taxIdentificationNumber: "",
      taxIdentificationType: "",
      remarks: "",
    };
  }

  //tax TAC Handler
  function taxTACHandler(e) {
    e.preventDefault();
    setShowTACDialog(true);
  }

  useEffect(() => {
    setDefaultValues();
    setCount(0)
     

  }, []);

  useEffect(() => {  
    if(count>0){ 
      setShowChequeUpload(true);
      changeShowUploadValue();
    }else{ 
      setCount(prev => prev + 1); 
    }
      
  }, [ values.personalInfoDTO.taxDeclarationDTO , values.personalInfoDTO.taxDeclarationDTO && values.personalInfoDTO.taxDeclarationDTO.taxDeclaration   ]);

  function setDefaultValues() {
    if (
      _.isEmpty(values.personalInfoDTO.taxDeclarationDTO) ||
      _.isEmpty(values.personalInfoDTO.taxDeclarationDTO.nationality)
    ) {
      setFieldValue(
        "personalInfoDTO.taxDeclarationDTO.nationality",
        CountryEnum.INDIA
      );
      setCount(0)
    }
    if (
      _.isEmpty(values.personalInfoDTO.taxDeclarationDTO) ||
      _.isEmpty(values.personalInfoDTO.taxDeclarationDTO.countryOfBirth)
    ) {
      setFieldValue(
        "personalInfoDTO.taxDeclarationDTO.countryOfBirth",
        CountryEnum.INDIA
      );
      setCount(0)
    }
  }

  return (
    <React.Fragment>

      <div className="content_body">
        <div className="row ">
          {/* Overall width control */}

          <div className="col-lg-8 col-sm-11 col-12 mx-auto">
            {/* Two Column Approach */}

            <div className="col-sm-11 col-12 mb-3 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplRadioButtonField
                    valuelist={residentialStatusList}
                    disabled={isDisabled}
                    rowdisplay={true}
                    label={"taxDeclaration.residentialStatus"}
                    name="personalInfoDTO.taxDeclarationDTO.residentOfIndia"
                    defaultValue={OptionsEnum.Resident}
                    onChange={handleDefaultResidentialStatus}
                    tooltip={"taxDeclaration.residentialStatusInfo"}
                    tooltipplace={"bottom"}
                  ></CsplRadioButtonField>
                </div>
                </div>
                </div>
                {values &&
                  values.personalInfoDTO &&
                  values.personalInfoDTO.taxDeclarationDTO &&
                  values.personalInfoDTO.taxDeclarationDTO.residentOfIndia &&
                  values.personalInfoDTO.taxDeclarationDTO.residentOfIndia !==
                    OptionsEnum.Resident && (
                      <div className="col-sm-11 col-12 mb-4 me-auto">
                      <div className="d-md-flex justify-content-between">
                       <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4" id="passportNo">         
                      <CsplTextBoxField
                        label={"taxDeclaration.passportNumber"}
                        name="personalInfoDTO.taxDeclarationDTO.passportNo"
                        required={true}
                        disabled={isDisabled}
                        id="passportNumber"/>
                     </div>
                <div className="w-100"></div>
              </div>
            </div>)}

            {/* One Column Approach */}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplTextBoxField
                    label="taxDeclaration.nationality"
                    name="personalInfoDTO.taxDeclarationDTO.nationality"
                    required={true}
                    disabled={isDisabled}
                    id="nationality"
                  />
                </div>
                <div className="w-100"></div>
              </div>
            </div>

            {/* Two Column Approach */}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplTextBoxField
                    label="taxDeclaration.countryOfBirth"
                    name="personalInfoDTO.taxDeclarationDTO.countryOfBirth"
                    required={true}
                    disabled={isDisabled}
                    id="countryOfBirth"
                    onValueChange={handleStateBasedOnCountry}
                  />
                </div>

                <div className="w-100">
                  {values &&
                  values.personalInfoDTO &&
                  values.personalInfoDTO.taxDeclarationDTO &&
                  values.personalInfoDTO.taxDeclarationDTO.countryOfBirth &&
                  values.personalInfoDTO.taxDeclarationDTO.countryOfBirth.toUpperCase() ===
                    CountryEnum.INDIA ? (
                    <CsplAchField
                      label={"taxDeclaration.stateOfBirth"}
                      name="personalInfoDTO.taxDeclarationDTO.stateOfBirthObj"
                      required={true}
                      lookupName={"stateShortName"}
                      displayColumn="name"
                      idColumn="id"
                      disabled={isDisabled}
                      id="residentialState"
                    />
                  ) : (
                    <CsplTextBoxField
                      label="taxDeclaration.stateOfBirth"
                      required={true}
                      name="personalInfoDTO.taxDeclarationDTO.stateOfBirth"
                      disabled={isDisabled}
                      id="stateOfBirth"
                    />
                  )}
                </div>
              </div>
            </div>

            {/* One Column Approach */}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplRadioButtonField
                valuelist={taxDeclaration}
                disabled={isDisabled}
                rowdisplay={false}
                label={"taxDeclaration.taxDeclaration"}
                name="personalInfoDTO.taxDeclarationDTO.taxDeclaration"
                defaultValue={OptionsEnum.Tax_Resident_Of_India_Only}
                onChange={handleTaxDeclaration}
              ></CsplRadioButtonField>
            </div>

            <div className="col-sm-11 col-12 mb-4 me-auto">
              {values &&
                values.personalInfoDTO &&
                values.personalInfoDTO.taxDeclarationDTO &&
                values.personalInfoDTO.taxDeclarationDTO.residentOfIndia &&
                values.personalInfoDTO.taxDeclarationDTO.residentOfIndia !==
                  OptionsEnum.Resident && (
                  <div className="d-flex flex-column">
                    <div className="col-sm-11 col-12 mb-4 me-auto">
                      <CsplDragDrop
                        label={"taxDeclaration.UploadPassport"}
                        required={true}
                        disabled={isDisabled}
                        base64FieldName={
                          "personalInfoDTO.taxDeclarationDTO.indianPassportImage"
                        }
                        fileNameFieldName={
                          "personalInfoDTO.taxDeclarationDTO.indianPassportFileName"
                        }
                        path={"personalInfoDTO.taxDeclarationDTO.indianPassportImagePath"}
                      ></CsplDragDrop>
                    </div>

                    <div className="col-sm-11 col-12 mb-4 me-auto">
                      <CsplDragDrop
                        label={ 
                          values.personalInfoDTO.taxDeclarationDTO.residentOfIndia !== 
                          OptionsEnum.OCI_Card_Holder ? "taxDeclaration.UploadVisaWorkPermit" : 
                          "taxDeclaration.UploadOCICard"}
                        required={true}
                        disabled={isDisabled}
                        base64FieldName={
                          "personalInfoDTO.taxDeclarationDTO.visaWorkPermitImage"
                        }
                        fileNameFieldName={
                          "personalInfoDTO.taxDeclarationDTO.visaWorkPermitFileName"
                        }
                        path={"personalInfoDTO.taxDeclarationDTO.visaWorkPermitImagePath"}
                      ></CsplDragDrop>
                    </div>

                    <div className="col-sm-11 col-12 mb-4 me-auto">
                      <CsplDragDrop
                        label={"taxDeclaration.CurrentOverseasAddress"}
                        required={true}
                        disabled={isDisabled}
                        base64FieldName={
                          "personalInfoDTO.taxDeclarationDTO.currentOverseasAddressProofImage"
                        }
                        fileNameFieldName={
                          "personalInfoDTO.taxDeclarationDTO.currentOverseasAddressProofFileName"
                        }
                        path={"personalInfoDTO.taxDeclarationDTO.currentOverseasAddressProofImagePath"}
                      ></CsplDragDrop>
                    </div>
                    {
                      
                      applicationContext.currentWidget.status === "Completed" &&  showChequeUpload === false &&
                      (values.personalInfoDTO.taxDeclarationDTO.chequeFileName === null || values.personalInfoDTO.taxDeclarationDTO.chequeFileName === undefined )  && 
                      values.personalInfoDTO.taxDeclarationDTO.indianPassportFileName && 
                      values.personalInfoDTO.taxDeclarationDTO.visaWorkPermitFileName && 
                      values.personalInfoDTO.taxDeclarationDTO.currentOverseasAddressProofFileName  ? 
                        <></> 
                    :
                    applicationContext.currentHolder.entityTypeName === "First Holder"? <div className="col-sm-11 col-12 mb-4 me-auto"> 
                      <CsplDragDrop
                      label={"taxDeclaration.UploadCheque"}
                      required={true}
                      disabled={isDisabled}
                      base64FieldName={
                        "personalInfoDTO.taxDeclarationDTO.chequeImage"
                      }
                      fileNameFieldName={
                        "personalInfoDTO.taxDeclarationDTO.chequeFileName"
                      }
                      path={"personalInfoDTO.taxDeclarationDTO.chequeImagePath"}
                    ></CsplDragDrop>
                     <div className="help_text">{t("taxDeclaration.UploadChequeNote")}</div>  
                   </div> :<></>
                    }
                  </div>
                )}
            </div>

            {/* One Column Approach */}
            <div className="col-sm-12 col-12 mb-4 me-auto">
              {values &&
                values.personalInfoDTO &&
                values.personalInfoDTO.taxDeclarationDTO &&
                values.personalInfoDTO.taxDeclarationDTO.taxDeclaration &&
                values.personalInfoDTO.taxDeclarationDTO.taxDeclaration !==
                  OptionsEnum.Tax_Resident_Of_India_Only && (
                  <div className=" tax-declaration-table mb-2 table-responsive-sm">
                    <br></br>
                    <table className=" table ">
                      <thead className="taxDeclaration_table_headBg">
                        <th className="p-2">
                          {t("taxDeclaration.countriesOfTaxResidency")}
                        </th>
                        <th className="p-2">
                          {t(
                            "taxDeclaration.taxidentificationNumberOrFunctionalEquivalent"
                          )}
                        </th>
                        <th className="p-2">
                          {t("taxDeclaration.identificationType")}
                        </th>
                        <th className="p-2">{t("taxDeclaration.remarks")}</th>
                        {!applicationContext.disableForm && (
                          <th className="p-2"></th>
                        )}
                      </thead>
                      <tbody>
                        <TaxResidenceTable
                          countryLookupName={taxResCountryLookupName}
                          onSaveToStore={props.onSaveToStore}
                        />
                      </tbody>
                    </table>
                  </div>
                )}
            </div>

            <div className="col-sm-12 col-12 mb-4 me-auto">
              <CsplCheckboxField
                name="personalInfoDTO.taxDeclarationDTO.taxTcAccepted"
                linktext={"taxDeclaration.taxTermsAndConditions"}
                onlinkclick={taxTACHandler}
                disabled={isDisabled}
              />
              {showTACDialog && (
                <AlertModal
                  isModalOpen={showTACDialog}
                  title={t("taxTermsAndCondition.title")}
                  setIsModalOpen={setShowTACDialog}
                  type={OK}
                >
                  <TaxDeclarationTermsAndCondition />
                </AlertModal>
              )}
            </div>

            <br />
            <br />
          </div>
        </div>
        <br />
      </div>
    </React.Fragment>
  );
}

export default TaxDeclaration;
